import { loadJson, saveJson } from '@/features/kitchen/storage/persist'

export const WASTE_STORAGE_KEY = 'superoti.kitchen.waste'

export type WasteStatus = 'draft' | 'submitted' | 'approved' | 'rejected' | 'done'

export type WasteBatchRecord = {
  id: string
  status: WasteStatus
  items: { qty: number; productName: string }[]
  updatedAt: string
  rejectionReason?: string
}

export const DEFAULT_WASTE_BATCHES: WasteBatchRecord[] = [
  {
    id: 'DSP-KIT-20260623-01',
    status: 'draft',
    updatedAt: 'Baru dibuat',
    items: [
      { productName: 'Roti coklat', qty: 5 },
      { productName: 'Donat gula', qty: 2 },
    ],
  },
  {
    id: 'DSP-KIT-20260622-02',
    status: 'submitted',
    updatedAt: 'Dikirim 22/06 15:20',
    items: [{ productName: 'Croissant', qty: 8 }],
  },
  {
    id: 'DSP-KIT-20260621-03',
    status: 'approved',
    updatedAt: 'Disetujui HO 21/06 10:00',
    items: [
      { productName: 'Roti keju', qty: 6 },
      { productName: 'Roti coklat', qty: 4 },
    ],
  },
  {
    id: 'DSP-KIT-20260620-05',
    status: 'rejected',
    updatedAt: 'Ditolak HO 20/06 09:15',
    rejectionReason: 'Qty donat melebihi stok retur tercatat.',
    items: [{ productName: 'Donat gula', qty: 20 }],
  },
]

export function loadWasteBatches<T extends WasteBatchRecord>(fallback: T[]): T[] {
  return loadJson<T[]>(WASTE_STORAGE_KEY) ?? fallback
}

export function saveWasteBatches<T>(batches: T[]): void {
  saveJson(WASTE_STORAGE_KEY, batches)
}

export function getWasteSummary() {
  const batches = loadWasteBatches(DEFAULT_WASTE_BATCHES)
  const drafts = batches.filter((b) => b.status === 'draft')
  const waitingHo = batches.filter((b) => b.status === 'submitted' || b.status === 'rejected')
  const readyExecute = batches.filter((b) => b.status === 'approved')

  return {
    draftCount: drafts.length,
    waitingHoCount: waitingHo.length,
    readyExecuteCount: readyExecute.length,
    rejectedCount: batches.filter((b) => b.status === 'rejected').length,
  }
}
